export enum EnumAccountsType {
  Checking = 'DDA',
  Saving = 'SDA',
  Pse = 'PSE'
}
